import React from "react";

// Navigate
import { useNavigate, useParams } from "react-router-dom";

// Mui
import { AccordionTheme } from "@/styles/mui/accordionTheme";
import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";
import { ThemeProvider } from "@mui/material/styles";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import Fade from "@mui/material/Fade";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
// Compoents
import Layout from "@/components/layout";
import StocktakeDetailCard from "@/components/stocktakeDetailCard";
import Title from "@/components/title";

// Fetch
import { getStocktakeItemdDiffById } from "@/fetch/fetchStock";

// Moment
import formatStocktakeString from "@/lib/formatStocktakeString";
import _ from "lodash";
import moment from "moment";
import "moment/locale/zh-hk";
const StocktakeDetailPage = (props) => {
  const { open, setOpen } = props;

  const { id } = useParams();

  // Navigate
  const navigate = useNavigate();

  // States
  const [stocktake, setStocktake] = React.useState({});
  const [slideTranOn, setSlideTranOn] = React.useState(false);
  const [isZoomFullScreenOpen, setZoomFullScreenOpen] = React.useState(false);
  const [photoSource, setPhotoSource] = React.useState("");
  const handleClickOpen = (src) => {
    setPhotoSource(src);
    setZoomFullScreenOpen(true);
  };
  const fetchAll = async () => {
    if (id) {
      const { data } = await getStocktakeItemdDiffById(id);

      setStocktake(data);
      setTimeout(() => {
        setSlideTranOn(true);
      }, 200);
    }
  };
  // turn off ZoomFullScreen
  const handleClose = () => {
    setZoomFullScreenOpen(false);
  };
  React.useEffect(() => {
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  moment.updateLocale("zh-hk", {
    weekdaysShort: ["日", "一", "二", "三", "四", "五", "六"],
  });

  return (
    <Layout
      header="StocktakeDetailPage"
      selectedIndex={19}
      open={open}
      setOpen={setOpen}
    >
      <Title title={`盤點詳細資料`} history={() => navigate(-1)} />
      <Grid container spacing={2}>
        <Grid
          size={{
            xs: 12,
            md: 12,
            lg: 12
          }}>
          <StocktakeDetailCard
            stocktake={stocktake}
            noHover={true}
            type={"shop"}
          />
        </Grid>
        <Grid size={12}>
          <Fade in={slideTranOn} mountOnEnter unmountOnExit>
            <div>
              <ThemeProvider theme={AccordionTheme}>
                {_.map(stocktake?.items, (item, index) => (
                  <Accordion
                    sx={{ width: "100%" }}
                    key={index}
                    TransitionProps={{ unmountOnExit: true }}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls={`panel-${index}`}
                      id={`panel-${index}-header`}
                    >
                      <Typography
                        color={
                          Number(item.sum) - Number(item.stockonhand_qty) !== 0
                            ? "red"
                            : "black"
                        }
                      >
                        {item.item_name}
                        {item.reason && (
                          <p>
                            {"差異原因："}
                            {item.reason}
                            {item.remark ? `(${item.remark})` : ``}
                          </p>
                        )}
                      </Typography>
                    </AccordionSummary>

                    <TableContainer>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell></TableCell>
                            <TableCell>到期日</TableCell>
                            <TableCell align="right"></TableCell>
                            <TableCell align="right">數量</TableCell>
                          </TableRow>
                        </TableHead>
                        {item?.qtys?.length > 0 ? (
                          <TableBody>
                            {_.map(item?.qtys, (qty, index) => {
                              return (
                                <TableRow key={index}>
                                  <TableCell>{index + 1}.</TableCell>
                                  <TableCell>
                                    {formatStocktakeString(qty)}
                                  </TableCell>
                                  <TableCell align="right"></TableCell>
                                  <TableCell align="right">{qty.qty}</TableCell>
                                </TableRow>
                              );
                            })}
                          </TableBody>
                        ) : (
                          <TableBody>
                            <TableCell
                              style={{ color: "red" }}
                              align="center"
                              colSpan={4}
                            >
                              沒有盤點
                            </TableCell>
                          </TableBody>
                        )}
                        <TableBody>
                          <TableRow>
                            <TableCell align="right" colSpan={3}>
                              盤點數量
                            </TableCell>
                            <TableCell align="right" colSpan={1}>
                              {item.sum}
                            </TableCell>
                          </TableRow>
                        </TableBody>
                        <TableBody>
                          <TableRow>
                            <TableCell align="right" colSpan={3}>
                              實際數量
                            </TableCell>
                            <TableCell align="right" colSpan={1}>
                              {item.stockonhand_qty}
                            </TableCell>
                          </TableRow>
                        </TableBody>
                        <TableBody>
                          <TableRow>
                            <TableCell
                              align="right"
                              colSpan={3}
                              style={{
                                color:
                                  Number(item.sum) -
                                    Number(item.stockonhand_qty) !==
                                  0
                                    ? "red"
                                    : "black",
                              }}
                            >
                              相差數量
                            </TableCell>
                            <TableCell
                              align="right"
                              colSpan={1}
                              style={{
                                color:
                                  Number(item.sum) -
                                    Number(item.stockonhand_qty) !==
                                  0
                                    ? "red"
                                    : "black",
                              }}
                            >
                              {Number(item.sum) - Number(item.stockonhand_qty)}
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Accordion>
                ))}
              </ThemeProvider>
            </div>
          </Fade>
        </Grid>
      </Grid>
    </Layout>
  );
};

export default StocktakeDetailPage;
